<template>
	<ul id="jobTypeChoice">
		<div class="template_input">
			<label>{{getLabel(params.label)}} <span v-if="params.compulsory" class="star">*</span>:</label>
			<li v-for="(value, key) in params.contractTypes">
				<input type="checkbox" v-bind:id="'jobType_'+key" v-bind:value="key" v-model="checkboxRes">
				<label v-bind:for="'jobType_'+key">{{getLabel(value.label)}}</label>
			</li>
		</div>
	</ul>
</template>

<script>

import componentTools from '@/libs/componentTools.js';
import lib from '@/libs/main.js';

export default {
	name: 'jobType_input',
	data() {
		return {
			checkboxRes : []
		}
	},
	props : ['params', 'oldValue', 'lang'],
	methods : {
		validate : function(v) {
			return v.length;
		},
		notifyUpdate : function(val) {
			this.$emit('validateField', this.params.name, val);
		},
		getLabel : componentTools.getLabel,
	},
	watch: {
		checkboxRes : function(val){
			if(this.validate(val)) this.notifyUpdate(val);
			else this.notifyUpdate();
		},
		oldValue : function(val){
			if(!val) this.checkboxRes = [];
		}
	},
	mounted : function(){
		if(Array.isArray(this.oldValue) && this.oldValue.length) this.checkboxRes = this.oldValue;
	}
};
</script>



// WEBPACK FOOTER //
// src/components/candidate_forms/jobType_input.vue